import { createFileRoute } from "@tanstack/react-router";
import { requireActive } from "../lib/require-active";

export const Route = createFileRoute("/challenges")({
  beforeLoad: ({ context }) => {
    requireActive(context);
  },
});
